var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"theme-container"}),_c('div',{staticClass:"pickr-container",class:{'active': _vm.getActiveCustomColor()}})])}
var staticRenderFns = []

export { render, staticRenderFns }